document.addEventListener("DOMContentLoaded", () => {
  const toggleBtn = document.getElementById("toggle-client-type");
  const toggleBtnMobile = document.getElementById("toggle-client-type--mobile");
  const isMobileMenu = () => window.matchMedia("(max-width: 989px)").matches;
  const privateClientTypeLabelElem = document.getElementById(
    "private-client-type-label",
  );
  const businessClientTypeLabelElem = document.getElementById(
    "business-client-type-label",
  );

  const privateClientTypeLabelElemMobile = document.getElementById(
    "private-client-type-label--mobile",
  );
  const businessClientTypeLabelElemMobile = document.getElementById(
    "business-client-type-label--mobile",
  );

  if (businessClientTypeLabelElem)
    businessClientTypeLabelElem.innerHTML = "Företag";
  if (privateClientTypeLabelElem)
    privateClientTypeLabelElem.innerHTML = "Privat";
  if (businessClientTypeLabelElemMobile)
    businessClientTypeLabelElemMobile.innerHTML = "Företag";
  if (privateClientTypeLabelElemMobile)
    privateClientTypeLabelElemMobile.innerHTML = "Privat";

  // --------------------------
  // LOAD SAVED STATE
  // --------------------------
  const savedState = localStorage.getItem("clientType"); // "private" eller "business"
  const customerLoggedIn = window.customerLoggedIn === true;

  if (customerLoggedIn) {
    const businessState = "business";
    toggleBtn?.setAttribute("data-state", businessState);
    toggleBtnMobile?.setAttribute("data-state", businessState);
    localStorage.setItem("clientType", businessState);
    sessionStorage.setItem("has_verified_age", "true");
    const popup = document.getElementById("age-verification-popup");
    if (popup) {
      popup.style.display = "none";
      popup.classList.remove("show");
      popup.remove();
    }
  } else if (savedState) {
    toggleBtn?.setAttribute("data-state", savedState);
    toggleBtnMobile?.setAttribute("data-state", savedState);
  }

  // ------------------------------------------
  // MOBILE DRAWER FALLBACK: Redirect if menu is empty
  // ------------------------------------------
  const setupMobileDrawerFallback = () => {
    if (!isMobileMenu()) return;

    const currentClientType =
      document
        .querySelector("#toggle-client-type--mobile")
        ?.getAttribute("data-state") || "business";

    // Endast drawer-menyn
    document
      .querySelectorAll(".menu-drawer li[data-fallback-url]")
      .forEach((link) => {
        if (currentClientType === "private") {
          // Rensa tidigare listeners (viktigt!)
          const cleanLink = link.cloneNode(true);
          link.parentNode.replaceChild(cleanLink, link);

          cleanLink.addEventListener("click", (e) => {
            e.preventDefault();
            window.location.href = "/collections/vara-viner-pa-systembolaget";
          });
        }
        // business → INGEN handler = drawer funkar normalt
      });
  };

  // ------------------------------------------
  // MEGAMENU FALLBACK: Redirect if menu is empty
  // ------------------------------------------
  const setupMegaMenuFallback = () => {
    if (isMobileMenu()) return;
    const currentClientType =
      document
        .querySelector("#toggle-client-type")
        ?.getAttribute("data-state") || "business";

    const parentMenuItems = document.querySelectorAll("li[data-fallback-url]");

    // Utility: replace summary to remove old listeners
    const replaceSummary = (summary, onClick) => {
      const newSummary = summary.cloneNode(true);
      summary.parentNode.replaceChild(newSummary, summary);

      if (onClick) {
        newSummary.addEventListener("click", onClick);
      }

      return newSummary;
    };

    parentMenuItems.forEach((menuItem) => {
      const fallbackUrl = menuItem.dataset.fallbackUrl;
      if (!fallbackUrl) return;

      const summary = menuItem.querySelector("summary");
      const submenu = menuItem.querySelector("ul");

      if (!summary || !submenu) return;

      // ------------------------------------------
      // FILTER CHILDREN BASED ON CLIENT TYPE
      // ------------------------------------------
      const children = submenu.querySelectorAll("li[data-client]");

      children.forEach((child) => {
        const client = child.dataset.client;

        // Reset first
        child.style.display = "";

        if (currentClientType === "business" && client === "private") {
          child.style.display = "none";
        }

        if (currentClientType === "private" && client === "business") {
          child.style.display = "none";
        }
      });

      // ------------------------------------------
      // PRIVATE MODE: FORCE REDIRECT
      // ------------------------------------------
      if (currentClientType === "private") {
        const caret = summary.querySelector("svg, .icon, span svg");
        if (caret) caret.style.display = "none";

        summary.style.paddingRight = "0.7rem";

        replaceSummary(summary, (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();

          window.location.href = "/collections/vara-viner-pa-systembolaget";
        });

        return;
      }

      // ------------------------------------------
      // BUSINESS MODE: ALWAYS ALLOW MEGAMENU
      // ------------------------------------------
      if (currentClientType === "business") {
        const caret = summary.querySelector("svg, .icon, span svg");
        if (caret) caret.style.display = "block";

        summary.style.paddingRight = "";

        // IMPORTANT:
        // Replace summary WITHOUT click handler
        // so native <details>/<summary> works
        replaceSummary(summary);

        return;
      }
    });
  };

  const toggleVisibility = (fromMobile = false) => {
    const currentClientType = fromMobile
      ? toggleBtnMobile.getAttribute("data-state")
      : toggleBtn.getAttribute("data-state");

    document.querySelectorAll("[data-client]").forEach((elem) => {
      if (elem.getAttribute("data-visibility-toggle-rule") === "hide") {
        elem.style.visibility =
          elem.dataset.client === currentClientType ? "" : "hidden";
      } else {
        if (currentClientType === "business") {
          // if (elem.dataset.client === "private") {
          //     elem.style.display = "none";
          // } else {
          //     elem.style.display = "";
          // }
          if (elem.dataset.client === "private-extra") {
            elem.style.display = "none";
          } else {
            elem.style.display = "";
          }
          // elem.style.display = ""; //leave this commented out, comment out if/else block above, and uncomment top if/else code above to not show private tagged products when business is toggled on
        } else if (currentClientType === "private") {
          if (
            elem.dataset.client !== "private" &&
            elem.dataset.client !== "private-extra" &&
            elem.dataset.client !== "all"
          ) {
            elem.style.display = "none";
          } else {
            elem.style.display = "";
          }
        }
      }
    });

    // ------------------------------------------
    // HIDE CHILDREN THAT HAVE SAME FALLBACK URL AS PARENT
    // ------------------------------------------
    document.querySelectorAll("li[data-fallback-url]").forEach((parent) => {
      const parentUrl = parent.dataset.fallbackUrl;
      if (!parentUrl) return;

      const submenu = parent.querySelector("ul");
      if (!submenu) return;

      submenu.querySelectorAll("li[data-client]").forEach((child) => {
        const childLink = child.querySelector("a");
        if (!childLink) return;

        const childUrl = childLink.getAttribute("href");

        // Hide child if its URL is the same as parent's fallback
        if (childUrl === parentUrl && currentClientType === "private") {
          child.style.display = "none";
        }
      });
    });

    // ------------------------------------------
    // CHECK IF PRODUCT GRID IS EMPTY
    // ------------------------------------------
    const list = document.querySelector("#product-grid, .product-grid");
    const emptyMessageElem = document.querySelector(
      "#client-type-empty-message",
    );
    const productSliderControls = document.querySelector(".slider-buttons");
    const productSliderTotalCountElem = document.querySelector(
      ".slider-counter--total",
    );
    const productSlider = document.querySelector(".grid.slider");

    // Count visible <li> inside the list
    if (list) {
      const anyVisible = list
        ? Array.from(list.querySelectorAll("li")).some((li) => {
            return li.style.display !== "none";
          })
        : null;

      // Show/hide empty message
      if (emptyMessageElem) {
        if (!anyVisible) {
          if (
            emptyMessageElem.getAttribute("data-dynamic-message") === "true"
          ) {
            if (currentClientType === "private") {
              emptyMessageElem.innerHTML =
                "Inga produkter matchar privat visning på denna sida. Vänligen navigera vidare.";
            } else {
              emptyMessageElem.innerHTML =
                "Inga produkter matchar företagsvisning på denna sida. Vänligen navigera vidare.";
            }
          }
          if (
            emptyMessageElem.getAttribute("data-dynamic-message-short") ===
            "true"
          ) {
            if (currentClientType === "private") {
              emptyMessageElem.innerHTML =
                "Inga produkter matchar privat visning.";
            } else {
              emptyMessageElem.innerHTML =
                "Inga produkter matchar företagsvisning.";
            }
          }

          emptyMessageElem.style.display = "";
        } else {
          emptyMessageElem.style.display = "none";
        }
      }

      if (anyVisible) {
        const visibleElemsArray = Array.from(list.querySelectorAll("li"))
          .map((li) => li.style.display !== "none")
          .filter((item) => item === true);

        if (productSliderTotalCountElem && productSlider) {
          if (!productSlider.dataset.scrollBound) {
            productSlider.addEventListener("scroll", () => {
              productSliderTotalCountElem.innerHTML =
                visibleElemsArray.length - 1;
            });
            productSlider.dataset.scrollBound = "true";
          }

          productSlider.scrollLeft = 0;
          productSliderTotalCountElem.innerHTML = visibleElemsArray.length - 1;
        }

        if (productSliderControls) {
          if (visibleElemsArray.length === 1) {
            productSliderControls.style.display = "none";
          } else {
            productSliderControls.style.display = "";
          }
        }
      } else {
        if (productSliderControls) {
          productSliderControls.style.display = "none";
        }
      }
    }

    document.querySelectorAll("[data-client-visible]").forEach((btn) => {
      const type = btn.getAttribute("data-client-visible");
      btn.style.display = type === currentClientType ? "" : "none";
    });

    setupMegaMenuFallback();
    setupMobileDrawerFallback();
  };

  const setAgeVerified = (clientType) => {
    if (toggleBtn) {
      toggleBtn.setAttribute("data-state", clientType);
      toggleVisibility();
    }
    if (toggleBtnMobile) {
      toggleBtnMobile.setAttribute("data-state", clientType);
      toggleVisibility();
    }

    localStorage.setItem("clientType", clientType);
    sessionStorage.setItem("has_verified_age", "true");
    const popup = document.getElementById("age-verification-popup");
    if (popup) {
      popup.style.display = "none";
      popup.classList.remove("show");
    }
  };

  // Initial render based on saved value
  toggleVisibility();

  // Run fallback detection on initial render
  setupMegaMenuFallback();
  setupMobileDrawerFallback();

  // Run age verification check on initial render
  checkAgeVerification();

  // --------------------------
  // HANDLE CLICK
  // --------------------------
  toggleBtn?.addEventListener("click", () => {
    if (customerLoggedIn) return;
    const nextState =
      toggleBtn.getAttribute("data-state") === "private"
        ? "business"
        : "private";

    toggleBtn.setAttribute("data-state", nextState);

    // SAVE TO LOCALSTORAGE
    localStorage.setItem("clientType", nextState);

    toggleVisibility();
  });

  toggleBtnMobile?.addEventListener("click", () => {
    if (customerLoggedIn) return;
    const nextState =
      toggleBtnMobile.getAttribute("data-state") === "private"
        ? "business"
        : "private";

    toggleBtnMobile.setAttribute("data-state", nextState);

    // SAVE TO LOCALSTORAGE
    localStorage.setItem("clientType", nextState);

    toggleVisibility(true);
    setupMobileDrawerFallback();
  });

  document
    .getElementById("age-continue-private")
    .addEventListener("click", () => setAgeVerified("private"));
  document
    .getElementById("age-continue-business")
    .addEventListener("click", () => setAgeVerified("business"));

  const declineBtn = document.getElementById("age-decline");
  if (declineBtn) {
    declineBtn.addEventListener("click", () => {
      if (document.referrer && document.referrer !== window.location.href) {
        window.location.href = document.referrer;
      } else {
        window.location.href = "https://www.google.com";
      }
    });
  }
});

const checkAgeVerification = () => {
  const popup = document.getElementById("age-verification-popup");
  if (!popup) return;

  const customerLoggedIn = window.customerLoggedIn === true;
  if (
    customerLoggedIn ||
    sessionStorage.getItem("has_verified_age") === "true"
  ) {
    popup.style.display = "none";
    return;
  }

  popup.style.display = "flex";
};

// Hantera AJAX-navigering i Shopify
document.addEventListener("shopify:section:load", checkAgeVerification);
document.addEventListener("turbo:load", checkAgeVerification);
document.addEventListener("page:load", checkAgeVerification);
